import { TONE_CLASSES } from "@/lib/constants";

export default function StatusBadge({ tone = "neutral", children, testId }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${TONE_CLASSES[tone] || TONE_CLASSES.neutral}`}
      data-testid={testId}
    >
      {children}
    </span>
  );
}
